module.exports = __webpack_public_path__ + "img/webexguide.f8153dae.jpg";